const Commons = (function() {
    function alertAndGoBack(msg) {
        alert(msg);
        history.go(-1);
    }

    function getURLParameters(url) {
        return (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
            (a, v) => (
                (a[v.slice(0, v.indexOf("="))] = v.slice(v.indexOf("=") + 1)), a
            ),
            {}
        );
    }

    function isEmpty(val) {
        return val == null || val == "" || !val.length;
    }

    return {
        alertAndGoBack,
        getURLParameters,
        isEmpty
    };
})();

export default Commons;



// WEBPACK FOOTER //
// ./member/js/common.js